

export enum Setting {
    TICKET_SOURCE = 27,
    END_USER_NOTES_COLOR = 33,
    YOUR_TEAM_DEFAULT = 40,
    Mimic = 80,
    Timepicket_Interval = 93,
    Ticket_Action_Filter = 85,
    USER_TIMEZONE = 104,
    REVELATIONS_COLLAPSED_STATE = 121,
    TOOLBAR_STATE = 133,
    NEW_TICKET_DETAILS = 137,
    SIDEBAR_STATE = 138,
    RIGHTBAR_STATE = 139,
    TICKET_DETAILS_PAGE_SIZE = 140,
    LOG_TICKET_WINDOW_STATE = 141

}
